/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-25 18:20:43
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-05 17:14:54
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/TopConfigs/CloneButton/index.tsx
 */
import React from 'react';
import Button from 'src/components/CloneButton';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { fetchContentHomepage } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorHomepage/slice';
import { useCloneBtnParams } from 'src/hooks/useCloneBtnParams';

const CloneBtn = (props) => {
  const params: any = useParams();
  const { contentUuid } = params;
  const _d = useDispatch();
  const _params = useCloneBtnParams();

  const handleOnClick = () => {
    _d(
      fetchContentHomepage({
        //1===true 0===false
        uuid: contentUuid,
        params: _params,
        isClone: true,
      }),
    );
  };
  return <Button onClick={handleOnClick} disabled={props?.disabled} />;
};
export default CloneBtn;
